export default __webpack_public_path__ + "static/media/wasp-metal.1c8c2ec9.png";